<template>
    <NuxtLayout>
        <ImmersionFrame />
        <NuxtPage />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {NuxtPage, ImmersionFrame} from '#components';
    import {useAsyncData, useHostSettings, useScripts, useHead} from '#imports';

    const {data, error} = await useAsyncData('host-settings', () => useHostSettings(), {deep: true});
    if (!error.value) {
        const {loadScripts} = useScripts(data.value);
        useHead({script: await loadScripts()});
    }
</script>
